import React from 'react';
import { restoreCasingInHighlight } from '../../utils/SearchHighlightUtils';
import './index.less';

const renderWithHighlight = (
	highlight,
	keys,
	defaultValue,
	shouldMatchDefaultValue = false,
	className = 'highlights_general'
) => {
	const highlightValue = highlight && highlight[keys];
	if (!highlightValue || !highlightValue[0]) {
		return defaultValue;
	}

	const isMatchingWithDefaultValue = shouldMatchDefaultValue
		? defaultValue && defaultValue.toString().includes(highlightValue[0].replace(/<\/?em>/g, ''))
		: true;

	if (!isMatchingWithDefaultValue) {
		return defaultValue;
	}

	return (
		<span className={className}>
			<span
				dangerouslySetInnerHTML={{
					__html:
						typeof defaultValue === 'string'
							? restoreCasingInHighlight(highlightValue[0], defaultValue)
							: highlightValue[0],
				}}
			/>
		</span>
	);
};

export default renderWithHighlight;
